import { render, staticRenderFns } from "./IMC.vue?vue&type=template&id=96bf4118&"
import script from "./IMC.vue?vue&type=script&lang=js&"
export * from "./IMC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports